export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedShown: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    }
  },
  watch: {
    show(value, oldValue) {
      if (oldValue !== value) {
        this.handleShowChange(value);
      }
    }
  },
  mounted() {
    this.handleShowChange(this.show);
  },
  methods: {
    handleShowChange(show) {
      if (show) this.$refs.modal.show();else this.$refs.modal.hide();
    }
  }
};